import { UserModel, UserRef } from '$tablet-app/src/app/auth/UserModel';
import useRecordThumbnail from '$tablet-app/src/app/images/hooks/useRecordThumbnail';
import { User } from '@akin-home/amplify';
import React, { FC } from 'react';
import {
  Image,
  ImageStyle,
  StyleSheet,
  TextStyle,
  TouchableOpacityProps,
  View,
  ViewStyle,
} from 'react-native';
import { color, layout, palette, spacing } from '../../theme';
import Text from '../Text';

function getStyles(
  width: number,
  height: number,
  borderWidth: number,
  padding: number,
  borderRadius: number
) {
  // generate an image with a double border. the view style background is the inner border
  const outerOffsets = 2 * (padding + borderWidth);
  const CONTAINER_STYLE: ViewStyle = {
    borderWidth,
    padding,
    borderRadius,
    backgroundColor: palette.white,
    width: width + outerOffsets,
    height: height + outerOffsets,
    overflow: 'hidden',
  };

  const IMAGE_STYLE: ImageStyle = {
    width,
    height,
    borderRadius: spacing[6],
    borderColor: palette.white,
  };
  return {
    CONTAINER_STYLE,
    IMAGE_STYLE,
  };
}

const { CONTAINER_STYLE, IMAGE_STYLE } = getStyles(
  30,
  30,
  3,
  spacing[1] / 2,
  spacing[6]
);

const TEXT: TextStyle = { color: 'white' };
const LETTER_CONTAINER = {
  height: '100%',
  borderRadius: spacing[6],
  borderColor: color.white,
};

/**
 * A list of preset names.
 */

export interface ProfileIconProps extends TouchableOpacityProps {
  style?: ViewStyle;
  imageStyle?: ViewStyle;
  profile: UserModel | User | UserRef;
}

export const ProfileIcon: FC<ProfileIconProps> = (props) => {
  const { style: styleOverride, profile, ...rest } = props;

  // Display the view as overlapping or not overalapping, depending on the preset show, and set the border color to
  // the value passed for the color preset
  const { uri } = useRecordThumbnail({ record: profile });
  const source = !uri ? undefined : typeof uri === 'string' ? { uri } : uri;

  const viewStyle = StyleSheet.flatten([
    CONTAINER_STYLE,
    styleOverride,
    { borderColor: profile?.profileColor || color.primary },
  ]);

  const imageStyle = StyleSheet.flatten([IMAGE_STYLE, props.imageStyle]);

  const letterContainerStyle = StyleSheet.flatten([
    layout.centerContent,
    LETTER_CONTAINER,
    { backgroundColor: profile.profileColor || color.primary },
  ]);

  return (
    <View style={viewStyle} {...rest} testID={'profile-icon-' + profile.id}>
      {source ? (
        <Image style={imageStyle} source={source} />
      ) : (
        <View style={letterContainerStyle}>
          <Text preset="bold" style={TEXT}>
            {(profile.name as string)[0]}
          </Text>
        </View>
      )}
    </View>
  );
};
